export default __webpack_public_path__ + "static/media/ic_canto_24.f77e9950.svg";